import React, { memo } from 'react';
import { useNavigate } from 'react-router-dom';

import { BoxTshirtEdit } from './BoxTshirtEdit';
import InfoContent from './InfoContent';
import { MoreInfoButton } from './MoreInfoButton';

import icPodium from '@/assets/ic_podium.svg';
import { Button, Card, Divider, Modal } from '@/components';
import { useIsDesktop } from '@/hooks/useIsDesktop';
import useTourney from '@/hooks/useTourney';
import ROUTES from '@/router/routes';
import { ResponseVerFechaOro } from '@/types/goldDate';

type Props = {
  tourney: ResponseVerFechaOro | null;
};

export const SidebarContentView: React.FC<Props> = memo(({ tourney }) => {
  const { isDesktop } = useIsDesktop();

  const { updateTourney, tourneyData } = useTourney();

  const navigate = useNavigate();
  return (
    <div className="lg:w-[426px] mt-[123px]">
      <BoxTshirtEdit />
      <Card className="p-0 bg-white w-full pt-6 pb-3 mt-2">
        <div className="flex items-center space-x-2 px-5">
          <figure>
            <img alt="Icono de titulo Mi Desempeño" src={icPodium} />
          </figure>
          <p className="font-bold text-lg">Mi desempeño</p>
        </div>
        <div className="flex justify-evenly w-full items-center my-4">
          <p className="flex-1 text-right pr-8 items-center justify-end flex space-x-2">
            <span>RANKING</span>{' '}
            <b
              className={`text-3xl ${
                tourney?.posicion &&
                tourney?.posicion !== '-' &&
                Number(tourney?.posicion) === 1
                  ? 'text-gdt-status-yellow'
                  : 'text-black'
              }`}
            >
              {tourney?.posicion ? `#${tourney?.posicion}` : '-'}
            </b>{' '}
          </p>
          <Divider className="h-10" type="vertical" />
          <p className="flex-1 pl-8 flex items-center justify-start space-x-2">
            <span>PUNTOS</span>{' '}
            <b className="text-2xl">{tourney?.puntos_general}</b>{' '}
          </p>
        </div>
        <Divider type="horizontal" />
        <div className="flex px-5 py-6 justify-between">
          {tourney?.fechasConRanking.length === 0 && (
            <p>
              Competí en la {tourney?.nombreFechaRanking} <br />
              con tu <b>Equipo de Primera</b>
            </p>
          )}
          <div className="flex-1 text-right">
            <Button
              className="flex-1"
              type="button"
              variant="secondary"
              onClick={() => navigate(ROUTES.myTeam11)}
            >
              Ver mi equipo
            </Button>
          </div>
        </div>
      </Card>

      <div className="text-center mt-4">
        <MoreInfoButton />

        {/* MODAL INFO */}
        <Modal
          className="w-[600px] text-center px-[38px]"
          controlledOnClose={() => {
            updateTourney({ showModalInfo: false });
          }}
          disableBodyScroll={true}
          isControlledOpen={Boolean(tourneyData.showModalInfo) && isDesktop}
          render={() => <InfoContent />}
          size="sm"
          variant="controlled"
        />
      </div>
    </div>
  );
});

SidebarContentView.displayName = 'SidebarContentView';
